import React from 'react';
import { Flex, Text, Button } from '@shopuptech/expo-shopup-ui';
import SvgAccessDenied from '../../Icons/SvgAccessDenied';
import { useHistory } from 'react-router-dom';
import { REQUEST_ACCESS_PATH } from '../../modules/mainhome/constants';
import { commonStyles } from '../../styles';
import { useUserLogin } from '../../hooks/useUserLogin';

const NoPermissionScreen = () => {
  const { replace } = useHistory();

  const { isRequestAccessFlow } = useUserLogin();

  const onRequestAccess = () => {
    replace(REQUEST_ACCESS_PATH);
  };
  return (
    <Flex center middle overrideStyle={commonStyles.overAllConatiner}>
      <Flex overrideStyle={commonStyles.overAll}>
        <Flex center>
          <SvgAccessDenied />

          <Text bold size={20} overrideStyle={commonStyles.accessText}>
            Access Denied
          </Text>
          <Text
            testID="no-permission-message"
            size={16}
            color="gray"
            overrideStyle={commonStyles.contactText}>
            You don’t have access to this page.
          </Text>

          <Text testID="no-permission-contact-prefix" size={16} color="gray">
            Please contact admin for more information.
          </Text>
        </Flex>
        {isRequestAccessFlow && (
          <Button
            testID="request-access-button"
            buttonSize="medium"
            onClick={onRequestAccess}
            contain>
            Request Access
          </Button>
        )}
      </Flex>
    </Flex>
  );
};

export default NoPermissionScreen;
